import RemoveBg from "./RemoveBg.jsx";
export default RemoveBg;